var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGaugePlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 353 269",
    enableBackground: "new 0 0 353 269",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    fill: "#C7C7C7",
    width: 109,
    height: 27
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    y: 31,
    fill: "#C7C7C7",
    width: 61,
    height: 16
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    y: 70,
    fill: "#C7C7C7",
    width: 242,
    height: 16
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    y: 90,
    fill: "#C7C7C7",
    width: 353,
    height: 16
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    y: 110,
    fill: "#C7C7C7",
    width: 353,
    height: 16
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    y: 130,
    fill: "#C7C7C7",
    width: 353,
    height: 16
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    y: 150,
    fill: "#C7C7C7",
    width: 353,
    height: 16
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    y: 170,
    fill: "#C7C7C7",
    width: 353,
    height: 16
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    x: 130,
    y: 31,
    fill: "#C7C7C7",
    width: 61,
    height: 16
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    x: 130,
    y: 11,
    fill: "#C7C7C7",
    width: 61,
    height: 16
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    x: 212,
    y: 11,
    fill: "#C7C7C7",
    width: 61,
    height: 16
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    x: 292,
    y: 11,
    fill: "#C7C7C7",
    width: 61,
    height: 16
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    x: 211,
    y: 31,
    fill: "#C7C7C7",
    width: 61,
    height: 16
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    x: 292,
    y: 31,
    fill: "#C7C7C7",
    width: 61,
    height: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_17_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -213.5877,
    y1: 735.8414,
    x2: -213.5877,
    y2: 734.9138,
    gradientTransform: "matrix(399 0 0 -290 85398 213394)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.937
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    fill: "url(#Rectangle_17_1_)",
    width: 353,
    height: 269
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaugePlaceholder);
export default __webpack_public_path__ + "static/media/gauge-placeholder.9e0fdd639a4938735033fc4adb9b1ac4.svg";
export { ForwardRef as ReactComponent };